import { toast } from "@coval/ui"

export const MISSING_CURRENT_USER_EMAIL_TOAST = {
  title: "Unable to save annotation",
  description:
    "We could not identify your user email. Please refresh and try again.",
} as const

// Call out the silent-revert failure — a 404 means this reviewer has no assignment row.
// Read the transport error shape structurally rather than with an `instanceof` so this
// stays free of a transport import; the shared normalizer handles every other failure.
export const showAnnotationSaveErrorToast = (error: unknown) => {
  const fields =
    error && typeof error === "object"
      ? (error as { status?: unknown })
      : undefined
  const status = typeof fields?.status === "number" ? fields.status : undefined

  if (status === 404) {
    toast.danger({
      title: "Can't save your review",
      description: "This conversation isn't available for you to review.",
    })
    return
  }

  toast.error({
    error,
    fallback: "Something went wrong — please try again.",
    title: "Couldn't save your review",
  })
}
